import NavBar from './NavBar';

export default NavBar;